<template>
  <nav class="navbar navbar-dark navbar-expand-lg">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/img/realms-logo.png" />
      </router-link>

      <button class="btn btn-primary d-lg-none me-3" type="button" v-b-modal.reg-modal>
        {{ $t('nav.register') }}
      </button>

      <b-navbar-toggle target="navcol-main"></b-navbar-toggle>

      <b-collapse id="navcol-main" is-nav>
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" to="/">{{ $t('nav.home') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/bracket"
              >{{ $t('nav.bracket') }}</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/all-teams"
              >{{ $t('nav.teams') }}</router-link
            >
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item me-3">
            <LanguageSwitcher />
          </li>
          <li class="nav-item d-none d-lg-block">
            <button class="btn btn-primary" type="button" v-b-modal.reg-modal>
              {{ $t('nav.register') }}
            </button>
          </li>
        </ul>
      </b-collapse>
    </div>

    <b-modal id="reg-modal" hide-footer size="lg">
      <template #modal-header="{ close }">
        <h4 class="modal-title"><strong>{{ $t('registration.title') }}</strong></h4>
        <button
          type="button"
          class="btn-close"
          @click="close()"
          :aria-label="$t('common.close')"
        ></button>
      </template>

      <p>
        <strong
          >1. {{ $t('registration.steps.step1') }}&nbsp;</strong
        ><a
          class="span-laccent"
          href="http://siderealms.com/discord"
          target="_blank"
          ><strong>{{ $t('registration.steps.step1-link') }}</strong></a
        >
      </p>
      <p>
        2. {{ $t('registration.steps.step2') }}<br />
      </p>
      <img v-if="this.$i18n.locale === 'lv'" class="img-fluid pb-3" src="@/assets/img/dc-channel-lv.png" />
      <img v-if="this.$i18n.locale === 'en'" class="img-fluid pb-3" src="@/assets/img/dc-channel-en.png" />
      <p>
        3. {{ $t('registration.steps.step3') }}<br />
      </p>
      <img v-if="this.$i18n.locale === 'lv'" class="img-fluid pb-3" src="@/assets/img/dc-actions-lv.png" />
      <img v-if="this.$i18n.locale === 'en'" class="img-fluid pb-3" src="@/assets/img/dc-actions-en.png" />
      <p>
        {{ $t('registration.help') }}
      </p>
    </b-modal>
  </nav>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: "Header",
  components: {
    LanguageSwitcher
  }
};
</script>
